module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/buttons/gradient-diagonal-buttons/gradient-diagonal-buttons.component.scss
// module id = ./src/app/features/buttons/gradient-diagonal-buttons/gradient-diagonal-buttons.component.scss
// module chunks = main